import React from "react";

export default (props) => {

  return (
    <React.Fragment>

      <h1 className="page-title">About</h1>
      <p>Do you need to send evidence to Hull City Council to support a benefit claim or service application?</p>
      <p>Use Hull MyScan to submit your paperwork to us. It's easy to use, secure and best of all you can do it from the comfort of your own home. No need to travel to our offices and no more queues! All you need is an internet connection and a device that can scan or take pictures.</p>
      <br />
      <p><strong>Evidence submissions cover only Hull City Council area at the moment.</strong></p>

    </React.Fragment>
  );
};
